import api from '@/api';
import { ListResult } from '@/core/request/ListResult';

import { API_BASE_URL } from '..';
import {
  CreateTaskApplicationRequest,
  TaskApplication,
} from './TaskApplication.types';

const CONTROLLER_URL = `${API_BASE_URL}/tasks/applications`;

export async function createTaskApplication(
  obj: CreateTaskApplicationRequest,
): Promise<TaskApplication> {
  const result = (await api.post(`${CONTROLLER_URL}`, obj, null)) as unknown;

  return result as TaskApplication;
}

export async function updateTaskApplication(
  obj: CreateTaskApplicationRequest,
): Promise<TaskApplication> {
  const result = (await api.put(`${CONTROLLER_URL}`, obj, null)) as unknown;

  return result as TaskApplication;
}

export async function listTaskApplications(
  taskId?: number,
): Promise<ListResult<TaskApplication>> {
  const result = (await api.get(
    `${CONTROLLER_URL}/task/${taskId}`,
    null,
  )) as unknown;

  return result as ListResult<TaskApplication>;
}

export async function deleteTaskApplication(taskId: number) {
  const result = (await api.remove(
    `${CONTROLLER_URL}/${taskId}`,
    {},
    null,
  )) as unknown;

  return result;
}
